import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { FerieService } from "../../core/service/ferie.service";
import { Ferie } from "../../core/model/ferie";

@Component({
  selector: "app-edit-ferier",
  templateUrl: "./edit-ferier.component.html",
  styleUrls: ["./edit-ferier.component.scss"],
})
export class EditFerierComponent implements OnInit {
  @Input()
  set ferie(value: Ferie) {
    if (value) {
      this._ferie = { ...value };
      if (this._ferie.ferieDate) {
        const dateString = this._ferie.ferieDate.split("-");
        this.fDate = new NgbDate(
          Number(dateString[0]),
          Number(dateString[1]),
          Number(dateString[2])
        );
      }
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
  get ferie(): Ferie {
    return this._ferie;
  }

  private _ferie: Ferie;
  fDate: NgbDate = new NgbDate(2021, 1, 1);

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _ferieService: FerieService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      label: [null, Validators.compose([Validators.required])],
      ferieDate: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    let month;
    month = this.fDate.month;
    if (this.fDate.month < 10) {
      month = "0" + this.fDate.month;
    }

    let day;
    day = this.fDate.day;
    if (this.fDate.day < 10) {
      day = "0" + this.fDate.day;
    }

    this.ferie.ferieDate = this.fDate.year + "-" + month + "-" + day;

    this._ferieService
      .update(this.ferie)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.ferie);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
